import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

import { DetalhesLotesManualV2Component } from './detalhes-lotes-manual-v2.component';
import { ContratosFooterV2Component } from './contratos-footer-v2/contratos-footer-v2.component';
import { ModalMsgRpaV2Component } from './modal-msg-rpa-v2/modal-msg-rpa-v2.component';
import { ModalPreviewEmailV2Component } from './modal-preview-email-v2/modal-preview-email-v2.component';
import { SubloteCardV2Component } from './sublote-card/sublote-card.component';

@NgModule({
  declarations: [
    DetalhesLotesManualV2Component,
    ContratosFooterV2Component,
    SubloteCardV2Component,
    ModalMsgRpaV2Component,
    ModalPreviewEmailV2Component,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  exports: [DetalhesLotesManualV2Component]
})
export class DetalhesLotesManualV2Module {}
